import Tooltip from "../../common/Tooltip";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import PlatformSelectBox from "../../common/PlatformSelectBox";
import Button from "../../common/Button";
import MultiSelectMenu from "../../common/MultiSelectMenu";
import { capitalize, upperCase } from "../../../utils/manipulateText";
import DatePicker from "../../common/DatePicker";
import MultiselectBox from "../../common/MultiselectBox";
import * as Icon from "react-feather";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { useSiteBreakdownAndFilters } from "../SiteBreakdownAndFilters";
import { useTranslation } from "react-i18next";

function Filter({
  loading,
  onRefreshReport,
  setCache,
  setShowConfig,
  setInitState,
}) {
  const location = useLocation();
  const userEmail = useSelector((state) => state?.auth?.user?.email);
  const selectedSite = useSelector((state) => state.site?.selectedSite);

  const {
    adPlacements,
    setAdPlacements,
    platformFilter,
    setPlatformFilter,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    breakdowns,
    selectedIncomes,
    setSelectedIncomes,
    setTableBreakdowns,
  } = useSiteBreakdownAndFilters();

  const onPlatformChange = (platformDataTag) => {
    setCache(null);
    setPlatformFilter(platformDataTag);
  };

  const onDateChange = (e) => {
    setCache(null);
    setEndDate(e.endDate);
    setStartDate(e.startDate);
  };

  const onAdPlacementChange = (placements) => {
    setAdPlacements(placements);
  };

  const { t } = useTranslation();

  return (
    <div className="pt-2 w-full md:w-auto">
      <label className="leading-8 text-gray-600 font-semibold text-sm ml-1">
        {capitalize(t("filter"))}
      </label>
      <br />
      <div className="flex flex-wrap items-center">
        <Tooltip
          title="platform"
          content={"you can filter platform which ads are served."}
        >
          <div className="mx-1 mb-1 md:mb-0 flex items-center justify-center ">
            <PlatformSelectBox
              title="platform"
              onPlatformChange={onPlatformChange}
              platformFilter={platformFilter}
              filters={selectedSite?.filters}
            />
          </div>
        </Tooltip>

        {selectedSite?.breakdowns?.includes("statType") && (
          <Tooltip
            title="income type"
            content={"you can filter revenue by income type."}
          >
            <div className="mb-1 md:mb-0 mx-1">
              <MultiSelectMenu
                data={selectedSite?.incomeTypes}
                title="income type"
                selectedParam={selectedIncomes}
                setSelectedParam={setSelectedIncomes}
              />
            </div>
          </Tooltip>
        )}

        {selectedSite?.filters?.includes("placement") &&
        selectedSite?.breakdowns?.includes("placement") ? (
          <Tooltip
            title="ad placement"
            content={
              "you can filter ad placements your ads are located at. you can see placements after you click here."
            }
          >
            <div className="mb-1 md:mb-0 mx-1">
              <MultiselectBox
                title="AD PLACEMENT"
                options={
                  selectedSite === null
                    ? []
                    : selectedSite.zones.map((a) => {
                        return {
                          id: a.id,
                          label: a.name + " (" + a.id + ")",
                        };
                      })
                }
                onChange={onAdPlacementChange}
                onConfig={false}
                defaultSelectedItems={adPlacements}
                customStyle={{
                  maxHeight: "300px",
                  maxWidth: "600px",
                }}
              />
            </div>
          </Tooltip>
        ) : selectedSite?.filters?.includes("tag") &&
          selectedSite?.breakdowns?.includes("tag") &&
          selectedSite?.tagMap ? (
          <Tooltip
            title="ad placement"
            content={
              "you can filter the tags your ads are located at. you can see tags after you click here."
            }
          >
            <div className="mb-1 md:mb-0 mx-1">
              <MultiselectBox
                title="AD PLACEMENT"
                options={
                  selectedSite === null
                    ? []
                    : Object.entries(selectedSite.tagMap).map(([id, name]) => ({
                        id,
                        label: name,
                      }))
                }
                onChange={onAdPlacementChange}
                defaultSelectedItems={adPlacements}
                customStyle={{
                  maxHeight: "300px",
                  maxWidth: "400px",
                }}
              />
            </div>
          </Tooltip>
        ) : null}

        <Tooltip title="date range" content={"you can filter date range."}>
          <div className="mb-1 md:mb-0 mx-1">
            <DatePicker
              mode="range"
              startDate={startDate}
              endDate={endDate}
              onChange={onDateChange}
            />
          </div>
        </Tooltip>

        <div className="mx-1 mb-1 md:mb-0 flex items-center justify-center ">
          <Tooltip
            title="schedule report"
            content={"you can schedule report."}
            customStyle="w-fit"
          >
            <span className="inline-flex p-1 border bg-gray-200 rounded-md mr-2">
              {
                <button
                  className={`flex items-center justify-center transition-all ease-out transition-fast font-bold px-2 py-1 rounded`}
                  onClick={() => {
                    var replacedbd = [...breakdowns];
                    if (replacedbd.indexOf("zone") !== -1) {
                      replacedbd.splice(
                        replacedbd.indexOf("zone"),
                        1,
                        "placement"
                      );
                    }

                    var replacedpl = [platformFilter];
                    if (replacedpl.indexOf("Desktop") !== -1) {
                      replacedpl.splice(
                        replacedpl.indexOf("Desktop"),
                        1,
                        "desktop"
                      );
                    }
                    if (replacedpl.indexOf("Mobile") !== -1) {
                      replacedpl.splice(
                        replacedpl.indexOf("Mobile"),
                        1,
                        "mobile"
                      );
                    }
                    const selectedSiteId = location.pathname.split("/")[2];
                    setInitState((initState) => ({
                      ...initState,
                      selectedSite: selectedSiteId,
                      operation: "create_site",
                      selectedBreakdowns: [...replacedbd],
                      selectedPlatforms: [...replacedpl],
                      selectedPlacements: adPlacements,
                      selectedUserBreakdowns: [...selectedSite?.breakdowns],
                      selectedUserPlatforms: [...selectedSite?.filters],
                      selectedSitePlacements: selectedSite?.zones,
                      emails: userEmail ? [userEmail] : [],
                    }));

                    setShowConfig(true);
                  }}
                >
                  <Icon.Clock
                    className="text-gray-600"
                    width="15"
                    height="15"
                  />
                  <span className="2xl:hidden text-xs font-bold ml-2">
                    {upperCase(t("schedule"))}
                  </span>
                </button>
              }
            </span>
          </Tooltip>
          <Tooltip
            title="refresh report"
            content={"you can refresh report."}
            customStyle="w-fit"
          >
            <Button
              loading={loading}
              color="empower"
              onClick={() => {
                setTableBreakdowns(breakdowns);
                onRefreshReport();
              }}
              icon={faSyncAlt}
            >
              <span className="2xl:hidden">
                {upperCase(t("apply filters"))}
              </span>
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export default Filter;
